"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TasksApi = exports.TasksApiFactory = exports.TasksApiFp = exports.TasksApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * TasksApi - axios parameter creator
 * @export
 */
const TasksApiAxiosParamCreator = function (axiosClientConfiguration) {
    return {
        /**
         *
         * @param {CreateTaskDto} createTask
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: (createTask, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createTask' is not null or undefined
            if (createTask === null || createTask === undefined) {
                throw new base_1.RequiredError('createTask', 'Required parameter createTask was null or undefined when calling createTask.');
            }
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createTask !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createTask !== undefined ? createTask : {})
                : (createTask || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyTasks: (ids, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new base_1.RequiredError('ids', 'Required parameter ids was null or undefined when calling deleteManyTasks.');
            }
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteTask.');
            }
            const localVarPath = `/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} taskId
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTask: (taskId, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taskId' is not null or undefined
            if (taskId === null || taskId === undefined) {
                throw new base_1.RequiredError('taskId', 'Required parameter taskId was null or undefined when calling executeTask.');
            }
            const localVarPath = `/tasks/{taskId}/execute`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getTask.');
            }
            const localVarPath = `/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks: (page, size, translate, sort, search, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasksCount: (page, size, sort, search, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {any} task
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTask: (id, task, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchTask.');
            }
            // verify required parameter 'task' is not null or undefined
            if (task === null || task === undefined) {
                throw new base_1.RequiredError('task', 'Required parameter task was null or undefined when calling patchTask.');
            }
            const localVarPath = `/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof task !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(task !== undefined ? task : {})
                : (task || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {TaskDto} task
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTask: (id, task, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling putTask.');
            }
            // verify required parameter 'task' is not null or undefined
            if (task === null || task === undefined) {
                throw new base_1.RequiredError('task', 'Required parameter task was null or undefined when calling putTask.');
            }
            const localVarPath = `/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof task !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(task !== undefined ? task : {})
                : (task || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ScheduleTaskDto} scheduleTask
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleTask: (scheduleTask, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scheduleTask' is not null or undefined
            if (scheduleTask === null || scheduleTask === undefined) {
                throw new base_1.RequiredError('scheduleTask', 'Required parameter scheduleTask was null or undefined when calling scheduleTask.');
            }
            const localVarPath = `/tasks/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof scheduleTask !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(scheduleTask !== undefined ? scheduleTask : {})
                : (scheduleTask || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is a very performant method for checking if a Task exists.
         * @summary Check if Task exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskExists: (id, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling taskExists.');
            }
            const localVarPath = `/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TasksApiAxiosParamCreator = TasksApiAxiosParamCreator;
/**
 * TasksApi - functional programming interface
 * @export
 */
const TasksApiFp = function (axiosClientConfiguration) {
    return {
        /**
         *
         * @param {CreateTaskDto} createTask
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(createTask, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).createTask(createTask, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyTasks(ids, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).deleteManyTasks(ids, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).deleteTask(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} taskId
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTask(taskId, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).executeTask(taskId, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).getTask(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks(page, size, translate, sort, search, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).getTasks(page, size, translate, sort, search, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasksCount(page, size, sort, search, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).getTasksCount(page, size, sort, search, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {any} task
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTask(id, task, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).patchTask(id, task, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {TaskDto} task
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTask(id, task, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).putTask(id, task, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ScheduleTaskDto} scheduleTask
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleTask(scheduleTask, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).scheduleTask(scheduleTask, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * This is a very performant method for checking if a Task exists.
         * @summary Check if Task exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskExists(id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.TasksApiAxiosParamCreator)(axiosClientConfiguration).taskExists(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.TasksApiFp = TasksApiFp;
/**
 * TasksApi - factory interface
 * @export
 */
const TasksApiFactory = function (axiosClientConfiguration, basePath, axios) {
    return {
        /**
         *
         * @param {CreateTaskDto} createTask
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(createTask, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).createTask(createTask, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyTasks(ids, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).deleteManyTasks(ids, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask(id, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).deleteTask(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} taskId
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTask(taskId, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).executeTask(taskId, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(id, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).getTask(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks(page, size, translate, sort, search, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).getTasks(page, size, translate, sort, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasksCount(page, size, sort, search, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).getTasksCount(page, size, sort, search, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {any} task
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTask(id, task, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).patchTask(id, task, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {TaskDto} task
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTask(id, task, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).putTask(id, task, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduleTaskDto} scheduleTask
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleTask(scheduleTask, translate, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).scheduleTask(scheduleTask, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a very performant method for checking if a Task exists.
         * @summary Check if Task exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskExists(id, options) {
            return (0, exports.TasksApiFp)(axiosClientConfiguration).taskExists(id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TasksApiFactory = TasksApiFactory;
/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
class TasksApi extends base_1.BaseAPI {
    /**
     *
     * @param {TasksApiCreateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    createTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).createTask(requestParameters.createTask, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiDeleteManyTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    deleteManyTasks(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).deleteManyTasks(requestParameters.ids, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiDeleteTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    deleteTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).deleteTask(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiExecuteTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    executeTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).executeTask(requestParameters.taskId, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    getTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).getTask(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiGetTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    getTasks(requestParameters = {}, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).getTasks(requestParameters.page, requestParameters.size, requestParameters.translate, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiGetTasksCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    getTasksCount(requestParameters = {}, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).getTasksCount(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.search, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiPatchTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    patchTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).patchTask(requestParameters.id, requestParameters.task, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiPutTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    putTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).putTask(requestParameters.id, requestParameters.task, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TasksApiScheduleTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    scheduleTask(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).scheduleTask(requestParameters.scheduleTask, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is a very performant method for checking if a Task exists.
     * @summary Check if Task exists
     * @param {TasksApiTaskExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskExists(requestParameters, options) {
        return (0, exports.TasksApiFp)(this.axiosClientConfiguration).taskExists(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TasksApi = TasksApi;
